// extracted by mini-css-extract-plugin
module.exports = {"loaderWrapper":"Loader_loaderWrapper__1pMGc","loader":"Loader_loader__3dIgY","spinner":"Loader_spinner__2oaTH","spin":"Loader_spin__YbG5F"};